import React from "react";
import HealthScreenForm from "./App";

const BloodCholesterolPage = () => {
  return <HealthScreenForm forcedService="blood and cholesterol checks" />;
};

export default BloodCholesterolPage;
